import Vue from 'vue'
import Toast from '../toast'
import MessageBoxVue from './message-box'
import DefaultConfirm from './default-confirm'

function openConfirm(Component, config, cb) {
  // 处理弹窗冲突
  Toast.instance && Toast.close()
  const {
    icon = false,
    title = '',
    description,
    descStyle,
    showCancel,
    confirmButtonText,
    cancelButtonText
  } = config
  function renderInnerComponent(h) {
    if (Component === DefaultConfirm) {
      return h(Component, {
        props: {
          icon,
          title,
          description,
          descStyle
        }
      })
    }
    return h(Component, {
      props: config
    })
  }
  const vue = new Vue({
    el: document.createElement('div'),
    render(h) {
      return h(
        MessageBoxVue,
        {
          props: {
            showCancel,
            confirmButtonText,
            cancelButtonText
          },
          on: {
            confirm() {
              if (typeof cb === 'function') {
                cb()
                vue.$emit('confirm')
              } else {
                vue.$emit('confirm')
              }
            },
            cancel() {
              vue.$emit('cancel')
            }
          }
        },
        [renderInnerComponent(h)]
      )
    }
  })
  document.body.appendChild(vue.$el)
  function destroy() {
    vue.$destroy()
    document.body.removeChild(vue.$el)
  }
  return new Promise((resolve, reject) => {
    vue.$once('confirm', () => {
      destroy()
      resolve()
    })
    vue.$once('cancel', () => {
      destroy()
      reject(new Error('modal.confirm cancelled'))
    })
  })
}

function merge(a, b) {
  return Object.assign(a, b)
}

function formatConfig(config) {
  const ret = {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  }
  if (typeof config === 'object') {
    return merge(ret, JSON.parse(JSON.stringify(config)))
  }
  if (typeof config === 'string') {
    return merge(ret, { title: config })
  }
}

export const MessageBox = {
  confirm(config) {
    return openConfirm(
      DefaultConfirm,
      merge(formatConfig(config), { showCancel: true })
    )
  },

  alert(config, cb) {
    return openConfirm(
      DefaultConfirm,
      merge(formatConfig(config), { showCancel: false }),
      cb
    )
  },

  open(Component, config = {}) {
    return openConfirm(
      Component,
      merge({ showCancel: true }, formatConfig(config))
    )
  }
}

export const DaMessage = {
  install(Vue) {
    Vue.prototype.$message = {
      confirm(config) {
        return MessageBox.confirm(config)
      },
      alert(config, cb) {
        return MessageBox.alert(config, cb)
      },
      open(...args) {
        return MessageBox.open(...args)
      }
    }
  }
}
